import React from 'react';
import {
  FaMobileAlt,
  FaBoxes,
  FaMapMarkerAlt,
  FaArrowRight,
} from 'react-icons/fa';

const Projects = () => {
  const projects = [
    {
      icon: <FaMobileAlt />,
      tag: 'Plateforme digitale',
      title: 'ZWACOP',
      description:
        'Plateforme de mise en relation entre clients et prestataires de services. Recherche, échange, demande et évaluation en un seul endroit. Une solution qui connecte les compétences aux opportunités.',
      status: 'En ligne',
    },
    {
      icon: <FaBoxes />,
      tag: 'Système de gestion',
      title: 'EDEN Manager',
      description:
        'Solution complète de gestion des stocks, des produits et des opérations. Un tableau de bord clair pour piloter son activité, optimiser les ressources et prendre des décisions éclairées.',
      status: 'En ligne',
    },
    {
      icon: <FaMapMarkerAlt />,
      tag: 'Géolocalisation',
      title: 'Solutions de tracking',
      description:
        'Suivi de véhicules en temps réel, gestion de flotte et optimisation des déplacements avec visualisation cartographique. Une solution pour améliorer la productivité et réduire les coûts.',
      status: 'En développement',
    },
  ];

  return (
    <section id="projets" className="projects section section-alt">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Nos projets</span>
          <h2 className="section-title">Des solutions concrètes pour des besoins réels</h2>
          <p className="section-subtitle">
            Découvrez les plateformes et outils que nous avons développés
            pour répondre aux besoins du marché africain et créer de la valeur.
          </p>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div className="project-card" key={index}>
              <div className="project-card-top">
                <div className="project-card-icon">{project.icon}</div>
                <span className="project-card-status">
                  <span className="project-card-status-dot"></span>
                  {project.status}
                </span>
              </div>
              <span className="project-card-tag">{project.tag}</span>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <a href="#contact" className="project-card-link">
                En savoir plus <FaArrowRight className="project-card-link-icon" />
              </a>
            </div>
          ))}
        </div>

        <div className="projects-cta">
          <p>Vous souhaitez développer une solution similaire pour votre organisation ?</p>
          <a href="#contact" className="btn btn-primary btn-lg">
            Parlons de votre projet <FaArrowRight className="btn-icon" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;